/* AdiBody - finestra "Scegli l'ufficio postale": elenco degli uffici dal piu vicino. Usata da ab-consegna.js.
   Uffici: elenco ufficiale Poste preso da Spedisci.online (assets/uffici-postali.json, creato dal programma Evasione Ordini).
   Ricerca per CAP/citta/indirizzo; per gli indirizzi uso Nominatim solo per trovare il punto, con ripiego su CAP/comune. */
(function () {
  if (window.abUffici) return;
  var NOMINATIM = 'https://nominatim.openstreetmap.org/search';
  var modale, alla_scelta, elenco, caricamento;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function el(html) {
    var t = document.createElement('template');
    t.innerHTML = html.trim();
    return t.content.firstChild;
  }
  function distanzaKm(a, b, c, d) {
    var R = 6371, x = ((c - a) * Math.PI) / 180, y = ((d - b) * Math.PI) / 180;
    var h = Math.sin(x / 2) * Math.sin(x / 2) + Math.cos((a * Math.PI) / 180) * Math.cos((c * Math.PI) / 180) * Math.sin(y / 2) * Math.sin(y / 2);
    return 2 * R * Math.asin(Math.sqrt(h));
  }
  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function titolo(s) {
    return String(s || '').toLowerCase().replace(/(^|[\s'\-\/.(])([a-zà-ú])/g, function (m, a, b) { return a + b.toUpperCase(); })
      .replace(/ (Di|Del|Della|Dello|Dei|Degli|Delle|Da|Dal|Dalla|E|Ed|In|Al|Alla|Allo|Ai|Agli|Alle|Sul|Sulla|Per|Con) /g, function (m) { return m.toLowerCase(); });
  }

  /* ---------------- elenco ufficiale ---------------- */
  function caricaElenco() {
    if (elenco) return Promise.resolve(elenco);
    if (caricamento) return caricamento;
    caricamento = fetch(window.abUfficiUrl, { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('elenco');
        return r.json();
      })
      .then(function (d) {
        elenco = (d.uffici || []).map(function (r) {
          return {
            codice: r[0], nome: 'Ufficio Postale ' + titolo(r[1]), indirizzo: titolo(r[2]), cap: r[3],
            citta: titolo(r[4]), prov: r[5], lat: r[6], lon: r[7], orari: r[8], sabato: r[9], cittaN: norm(r[4])
          };
        }).filter(function (u) { return u.lat && u.lon; });
        return elenco;
      })
      .catch(function (e) {
        caricamento = null;
        throw e;
      });
    return caricamento;
  }
  function centro(lista) {
    var la = 0, lo = 0;
    lista.forEach(function (u) { la += u.lat; lo += u.lon; });
    return [la / lista.length, lo / lista.length];
  }

  /* ---------------- finestra ---------------- */
  function creaModale() {
    if (modale) return modale;
    modale = el(
      '<div class="ab-uffici" role="dialog" aria-modal="true" aria-label="Scegli l\'ufficio postale" hidden>' +
        '<div class="ab-uffici__sfondo" data-ab-chiudi></div>' +
        '<div class="ab-uffici__box">' +
        '<div class="ab-uffici__testa"><span><strong>Scegli l\'ufficio postale</strong><small class="ab-uffici__sotto" style="display:block;margin-top:2px;font-size:1.2rem;font-weight:400;opacity:.7">Solo uffici postali Poste Italiane: puoi pagare anche alla consegna</small></span>' +
        '<button type="button" class="ab-uffici__x" data-ab-chiudi aria-label="Chiudi">&times;</button></div>' +
        '<form class="ab-uffici__cerca">' +
        '<input type="text" inputmode="search" autocomplete="off" placeholder="CAP, città o indirizzo" aria-label="CAP, città o indirizzo">' +
        '<button type="submit">Cerca</button>' +
        '</form>' +
        '<button type="button" class="ab-uffici__posizione" data-ab-posizione>Usa la mia posizione</button>' +
        '<div class="ab-uffici__corpo">' +
        '<div class="ab-uffici__lista"><p class="ab-uffici__vuoto">Scrivi il tuo CAP, la città o il tuo indirizzo per vedere gli uffici postali più vicini.</p></div>' +
        '</div>' +
        '</div>' +
        '</div>'
    );
    document.body.appendChild(modale);
    modale.querySelector('form').addEventListener('submit', function (e) {
      e.preventDefault();
      var q = modale.querySelector('input').value.trim();
      if (q) cercaTesto(q);
    });
    modale.addEventListener('click', function (e) {
      if (e.target.closest('[data-ab-chiudi]')) chiudiModale();
      if (e.target.closest('[data-ab-posizione]')) cercaPosizione();
      var b = e.target.closest('[data-ab-ufficio]');
      if (b && b.__ufficio && alla_scelta) { chiudiModale(); alla_scelta(b.__ufficio); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modale && !modale.hidden) chiudiModale();
    });
    return modale;
  }
  function apriModale() {
    creaModale();
    modale.hidden = false;
    document.documentElement.classList.add('ab-uffici-aperto');
    caricaElenco().catch(function () {});  // lo scarico mentre il cliente scrive
    setTimeout(function () {
      modale.querySelector('input').focus();
    }, 50);
  }
  function chiudiModale() {
    if (!modale) return;
    modale.hidden = true;
    document.documentElement.classList.remove('ab-uffici-aperto');
  }
  function lista(html) {
    modale.querySelector('.ab-uffici__lista').innerHTML = html;
  }
  function nonDisponibile() {
    lista('<p class="ab-uffici__vuoto">Elenco degli uffici non disponibile in questo momento. Riprova tra poco oppure scegli la consegna a domicilio.</p>');
  }

  /* ---------------- ricerca ---------------- */
  function cercaTesto(q) {
    lista('<p class="ab-uffici__vuoto">Cerco…</p>');
    caricaElenco()
      .then(function (tutti) {
        var soloCap = /^\d{5}$/.test(q), n = norm(q), vicini = [];
        if (soloCap) {
          vicini = tutti.filter(function (u) { return u.cap === q; });
        } else {
          vicini = tutti.filter(function (u) { return u.cittaN === n; });
          if (!vicini.length && n.length >= 4) vicini = tutti.filter(function (u) { return u.cittaN.indexOf(n) === 0; });
        }
        if (vicini.length) {
          var c = centro(vicini);
          return mostraVicini(tutti, c[0], c[1]);
        }
        // indirizzo completo (o CAP/comune senza uffici): cerco il punto preciso su Nominatim
        function ripiego() {
          // Nominatim non trova o non risponde: uso il CAP o il comune scritti nel testo
          var capTesto = (q.match(/\b\d{5}\b/) || [])[0], v = [];
          if (capTesto) v = tutti.filter(function (u) { return u.cap === capTesto; });
          var parole = n.split(' ');
          for (var k = 0; k < parole.length && !v.length; k++) {
            var pezzo = parole.slice(k).join(' ');
            if (pezzo.length >= 3) v = tutti.filter(function (u) { return u.cittaN === pezzo; });
          }
          for (var k2 = parole.length; k2 > 0 && !v.length; k2--) {
            var inizio = parole.slice(0, k2).join(' ');
            if (inizio.length >= 3) v = tutti.filter(function (u) { return u.cittaN === inizio; });
          }
          if (v.length) {
            var c2 = centro(v);
            return mostraVicini(tutti, c2[0], c2[1]);
          }
          lista('<p class="ab-uffici__vuoto">Non troviamo "' + esc(q) + '". Prova con il CAP o il nome del comune.</p>');
        }
        var ctrl = window.AbortController ? new AbortController() : null;
        var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 6000) : null;
        var url = NOMINATIM + '?format=json&limit=1&countrycodes=it&accept-language=it&' +
          (soloCap ? 'postalcode=' + encodeURIComponent(q) : 'q=' + encodeURIComponent(q));
        return fetch(url, { headers: { Accept: 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            clearTimeout(timer);
            if (d && d.length) return mostraVicini(tutti, parseFloat(d[0].lat), parseFloat(d[0].lon));
            ripiego();
          })
          .catch(function () {
            clearTimeout(timer);
            ripiego();
          });
      })
      .catch(nonDisponibile);
  }
  function cercaPosizione() {
    if (!navigator.geolocation) {
      lista('<p class="ab-uffici__vuoto">Il tuo dispositivo non condivide la posizione: cerca il CAP o la città.</p>');
      return;
    }
    lista('<p class="ab-uffici__vuoto">Cerco la tua posizione…</p>');
    navigator.geolocation.getCurrentPosition(
      function (p) {
        caricaElenco()
          .then(function (tutti) { mostraVicini(tutti, p.coords.latitude, p.coords.longitude); })
          .catch(nonDisponibile);
      },
      function () { lista('<p class="ab-uffici__vuoto">Posizione non disponibile: cerca il CAP o la città.</p>'); },
      { timeout: 10000 }
    );
  }
  function mostraVicini(tutti, lat, lon) {
    var uffici = tutti
      .map(function (u) { return { u: u, km: distanzaKm(lat, lon, u.lat, u.lon) }; })
      .sort(function (a, b) { return a.km - b.km; })
      .slice(0, 20);
    if (!uffici.length) {
      lista('<p class="ab-uffici__vuoto">Nessun ufficio postale trovato qui vicino. Prova un altro CAP.</p>');
      return;
    }
    var box = modale.querySelector('.ab-uffici__lista');
    box.innerHTML = '';
    box.appendChild(el('<p class="ab-uffici__conta">' + uffici.length + ' uffici postali, dal più vicino</p>'));
    uffici.forEach(function (x) {
      var u = x.u;
      var orari = [u.orari ? 'Lun-Ven ' + u.orari : '', u.sabato ? 'Sab ' + u.sabato : ''].filter(Boolean).join(' · ');
      var b = el(
        '<button type="button" class="ab-uffici__voce" data-ab-ufficio>' +
          '<strong>' + esc(u.nome) + '</strong>' +
          '<span>' + esc(u.indirizzo + ', ' + u.cap + ' ' + u.citta) + '</span>' +
          (orari ? '<span>' + esc(orari) + '</span>' : '') +
          '<em>' + (x.km < 1 ? Math.round(x.km * 1000) + ' m' : x.km.toFixed(1).replace('.', ',') + ' km') + '</em>' +
          '<span class="ab-uffici__cta">Ritira qui</span>' +
        '</button>'
      );
      b.__ufficio = {
        codice: u.codice, nome: u.nome, indirizzo: u.indirizzo + ', ' + u.cap + ' ' + u.citta + (u.prov ? ' (' + u.prov + ')' : ''),
        lat: u.lat, lon: u.lon
      };
      box.appendChild(b);
    });
  }

  window.abUffici = {
    apri: function (cb) { alla_scelta = cb; apriModale(); },
    chiudi: chiudiModale
  };
})();